'use strict';

//This directive is to delay the loading of all Google Tag Manager type scripts
//until after AngularJS has has a change to load itself.

namespace Core {
    class Gtm {
        constructor (
            $element: JQuery,
            $timeout: ng.ITimeoutService
        ) {
            $timeout(() => {
                $element.append('<script src="build/gtm/gtm-bundle.js" async></script>');
                if (TRPCONFIG.Domain.GtmHelpersScriptEnabled) {
                    $element.append('<script src="build/gtm/gtm-helpers.js" async></script>');
                }
            }, 1000);
        }
    }
    angular
        .module('core')
        .directive('gtm', (): ng.IDirective => {
            return {
                restrict: 'E',
                controller: Gtm
            };
        });
}
